import React, { CSSProperties, FC, ReactNode } from "react";
import styled from "styled-components";

const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: center;
	align-content: center;
	padding: 5px;
	margin: 5px;
`;

const IconWrapper = styled.div`
	border-radius: 10px;
	background-color: ${props => props.theme.colors.primary};
	padding: 5px;
`;

const TextWrapper = styled.div`
	width: 100%;
	height: 22px;

	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	align-content: center;

	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 165.5%;
	background: #ffffff;
	box-shadow: 0px 4px 39px 6px rgba(0, 0, 0, 0.07);
	border-radius: 0px 8px 8px 0px;
`;

interface ButtonCategoryProps {
	label?: string;
	icon?: ReactNode;
	style?: CSSProperties;
	onClick?: () => void;
}

const ButtonCategory: FC<ButtonCategoryProps> = ({ label, icon, style, onClick }) => {
	return (
		<div style={style} onClick={onClick}>
			<ButtonWrapper>
				<IconWrapper>{icon}</IconWrapper>
				<TextWrapper>{label}</TextWrapper>
			</ButtonWrapper>
		</div>
	);
};

export default ButtonCategory;
